import { __decorate } from 'vscode/external/tslib/tslib.es6.js';
import { transformErrorFromSerialization, onUnexpectedError } from 'vscode/vscode/vs/base/common/errors';
import { extHostNamedCustomer } from '../../services/extensions/common/extHostCustomers.js';
import { MainContext } from 'vscode/vscode/vs/workbench/api/common/extHost.protocol';

let MainThreadErrors = class MainThreadErrors {
    dispose() {
    }
    $onUnexpectedError(err) {
        if (err && err.$isError) {
            err = transformErrorFromSerialization(err);
        }
        onUnexpectedError(err);
    }
};
MainThreadErrors = __decorate([
    extHostNamedCustomer(MainContext.MainThreadErrors)
], MainThreadErrors);

export { MainThreadErrors };
